import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import RowEditIcon from './RowEditIcon';
import eyeIcon from '../../svgs/eye-details-icon.svg';
import PageTooltip from './PageTooltip';
import { TableCell } from '@mui/material';

// pass row object as prop
const SubCompanyRow = ({ row, count, tableHeader, enableEdit ,stickyEnabled}) =>{
    // get context variables from parent 
    const {
        editSubCompanyModal, 
        setEditSubCompanyModal,
        editSubCompanyRow,
        setEditSubCompanyRow,
        editAccountIdsModal, 
        setEditAccountIdsModal, 
    } = useContext(PageContext);  

    // event handler for edit icon click 
    const onEditClick = () =>{
        // make EditSubCompanyModal visible using state variable from context 
        setEditSubCompanyModal(editSubCompanyModal => editSubCompanyModal = true);
        // set row for use in EditSubCompanyModal 
        setEditSubCompanyRow(editSubCompanyRow => editSubCompanyRow = row);
    }

    // event handler for view accout ids click
    const onViewClick = () => {
        // set row for use in EditAccountIdsModal 
        setEditSubCompanyRow(editSubCompanyRow => editSubCompanyRow = row);
        // make edit account ids modal visible
        setEditAccountIdsModal(editAccountIdsModal => editAccountIdsModal = true); 
    }

    // display red circle for disabled (0) status or green circle for active (1) status
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    // blank (empty or whitespace only) string check, used for integrator column
    const isBlankString = (value) => typeof value === 'string' && value.trim() === '';

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {/* map logic over ever column in row object */}
            {tableHeader.map(el =>
                // if status column apply statusIcon function 
                el['columnname'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                : el['columnname'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        {/* show edit icon to trigger EditSubCompanyRow modal */}
                        <RowEditIcon enable={enableEdit} onClick={onEditClick}/>
                    </TableCell>
                : el['columnname'] == 'viewaccountids' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        <PageTooltip title='Account IDs'>
                            <img src={eyeIcon} className='data-table-icon-left' onClick={(e)=>onViewClick(e)}/>
                        </PageTooltip>
                    </TableCell>
                : (row[el['columnname']] == null || (el['columnname'] == 'integrator' && isBlankString(row[el['columnname']]))) ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                // standard display for all other columns 
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
            
        </>
    );
}

export default SubCompanyRow; 